import { useRef, useEffect } from 'react'

export const useOnScroll = (callback: () => void) => {
  const savedCallback = useRef<() => void>()

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const callback = () => {
      if (savedCallback.current) {
        savedCallback.current()
      }
    }
    document.addEventListener('scroll', callback, true)

    return () => {
      document.removeEventListener('scroll', callback, true)
    }
  }, [])
}
